import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import extractErrorMessage from "util/extractErrorMessage";
import { searchEventsAlerts, bulkScheduleEventDefinitions } from "./api/eventsAPI";
export function useSearchEventsAlerts() {
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: searchEventsAlerts,
    onError: (error) => UserNotification.error(error.message)
  });
  return {
    searchEventsAlerts: mutateAsync,
    searchingEventsAlerts: isLoading
  };
}
export function useEnableEventDefinitions() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: bulkScheduleEventDefinitions,
    onSuccess: async (_data, entityIds) => {
      UserNotification.success(
        i18n.t("notifications.enabled_event_definitions", {
          ns: "enterprise_security_events",
          count: entityIds.length
        })
      );
      await queryClient.invalidateQueries({ queryKey: ["get-threat-related-event-definitions"] });
      await queryClient.invalidateQueries({ queryKey: ["threat-coverage"] });
    },
    onError: (error) => UserNotification.error(
      i18n.t("notifications.failed_enable_event_definitions", {
        ns: "enterprise_security_events",
        error: extractErrorMessage(error)
      })
    )
  });
  return {
    enableEventDefinitions: mutateAsync,
    enablingEventDefinitions: isPending
  };
}
